// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { mergeStyles } from '@fluentui/react';

/**
 * @private
 */
export const loadingStyle = mergeStyles({
  height: '100%',
  width: '100%'
});